@if (visible$()) {
  <div data-shortcut-layer="popover" class="lab-popovers-container" (scroll)="$event.preventDefault()">
    @for (popover of popovers$(); track popover.id; let last = $last) {
      @if (last) {
        <div class="lab-popovers-glass-pane" (mousedown)="onGlassPaneMousedown(popover.id, $event)"></div>
      }
      <lab-popover [data]="popover" [cdkTrapFocus]="last" />
    }
  </div>
}
